// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post/put/delete çağrılarına bağlanacak.
let mockCompanies = [
    {
        id: 1,
        company_id: 1,
        name: "Kalt Elektronik",
        address: "Maslak/İstanbul",
        staff_count: 4800,
        status: "active",
        description: "Teknoloji A.Ş."
    }
];
let nextId = 2;

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockCompanies];

    if (filter.company_id) {
        rows = rows.filter((row) => String(row.company_id).includes(String(filter.company_id)));
    }
    if (filter.name) {
        rows = rows.filter((row) => row.name.toLowerCase().includes(filter.name.toLowerCase()));
    }
    if (filter.address) {
        rows = rows.filter((row) => row.address.toLowerCase().includes(filter.address.toLowerCase()));
    }
    if (filter.status) {
        rows = rows.filter((row) => row.status === filter.status);
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const get = async (id) => {
    const row = mockCompanies.find((item) => item.id === Number(id));
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

const store = async (data) => {
    const row = {...data, id: nextId++};
    mockCompanies.push(row);
    return Promise.resolve({
        data: {
            data: row,
            message: "successfully_created"
        }
    });
};

const update = async (id, data) => {
    const index = mockCompanies.findIndex((item) => item.id === Number(id));
    if (index !== -1) {
        mockCompanies[index] = {...mockCompanies[index], ...data};
    }
    return Promise.resolve({
        data: {
            data: mockCompanies[index],
            message: "successfully_updated"
        }
    });
};

const remove = async (id) => {
    mockCompanies = mockCompanies.filter((item) => item.id !== Number(id));
    return Promise.resolve({
        data: {
            message: "successfully_deleted"
        }
    });
};

export default {
    getAll,
    get,
    store,
    update,
    remove
}
